document.addEventListener('DOMContentLoaded', function() {
    const button = document.getElementById('fixedMobileButton');
    if (!button) return;

    function handleScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const windowHeight = window.innerHeight;
        const documentHeight = document.documentElement.scrollHeight;

        // Calcular si estamos cerca del final (dentro de 150px del final)
        const distanceFromBottom = documentHeight - (scrollTop + windowHeight);

        if (distanceFromBottom < 150) {
            button.classList.add('hidden-button');
        } else {
            button.classList.remove('hidden-button');
        }
    }

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Ejecutar al cargar
});
